import * as React from 'react';

const SvgStability = (props) => (
  <svg
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    {...props}
  >
    <path
      d='M37.778 4.667H18.225C9.73 4.667 4.668 9.73 4.668 18.223v19.53c0 8.517 5.063 13.58 13.557 13.58h19.53c8.493 0 13.556-5.063 13.556-13.556V18.223c.024-8.493-5.04-13.556-13.533-13.556Zm1.61 22.236c0 .91-.723 1.634-1.633 1.634s-1.634-.724-1.634-1.634v-.42l-6.346 6.347c-.35.35-.817.513-1.307.467a1.55 1.55 0 0 1-1.19-.724l-2.38-3.546-5.553 5.553a1.568 1.568 0 0 1-1.144.467c-.42 0-.84-.164-1.143-.467-.63-.63-.63-1.657 0-2.31l6.953-6.953c.35-.35.817-.514 1.307-.467.49.047.933.303 1.19.723l2.38 3.547 4.923-4.923h-.42c-.91 0-1.633-.724-1.633-1.634 0-.91.723-1.633 1.633-1.633h4.34a2 2 0 0 1 .63.117c.397.163.724.49.887.886.093.21.117.42.117.63v4.34h.023Z'
      fill='currentColor'
    />
  </svg>
);

export default SvgStability;
